export default __webpack_public_path__ + "static/media/photoshop.0f5dea15.svg";